import * as defaultImport from "@splunk/react-ui/Search";
export * from "@splunk/react-ui/Search";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
